import React from "react";
import { getSEOData } from "../../../../global/utils/constants/seoConfig";
import SEO from "../../../../global/components/SEO/SEO";
import CredentialContent from "../Components/CredentialContent";

const Credential = () => {
    const seoData = getSEOData("/credential");

    return (
        <>
            <SEO
                title={seoData.title}
                description={seoData.description}
                keywords={seoData.keywords}
                type="website"
            />
            < CredentialContent />
        </>
    );
};

export default Credential;